module.exports = __webpack_public_path__ + "media/images/athletes/2833-52c33caa8cb64c1521d65ed38deb3cde.png";